import { getStandardBranchContainer } from '../factory';
import { EN_STANDARD_BRANCH_NAMESPACE, ISymbol } from '../types/interface';
import { EN_UI_PLUGIN_SYMBOL, IUIPluginManager } from './interface';

export class UIPluginManager implements IUIPluginManager {
  private _namespace = EN_STANDARD_BRANCH_NAMESPACE.UI_PLUGIN;

  public register(symbol: ISymbol, service: any, description?: string): void {
    if (!Object.values(EN_UI_PLUGIN_SYMBOL).includes(symbol)) {
      throw new Error(`${symbol}未识别`);
    }

    getStandardBranchContainer().register({
      namespace: this._namespace,
      symbol,
      description,
      value: service,
    });
  }
  public getPlugins(symbol: EN_UI_PLUGIN_SYMBOL): JSX.Element[] {
    return getStandardBranchContainer()
      .getAllSymbolized(this._namespace, symbol)
      .map((v: any) => v.value);
  }
}
